import { inClass } from "../../../../../utils/Helpers";

export const handleMouseUp = (e, ref, isText) => {
  const builderElement = inClass("builder-component--active", ref.current);
  builderElement?.setAttribute("draggable", "false");
};
